module.exports = __webpack_public_path__ + "static/media/historique.5b90528b.png";